import Vue from 'vue'
import es from 'vee-validate/dist/locale/es.json'
import en from 'vee-validate/dist/locale/en.json'
import * as rules from 'vee-validate/dist/rules'
// import i18n from '../i18n'
import { extend, localize, ValidationProvider, ValidationObserver } from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
localize({
  en,
  es
})
Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule]
  })
})

let LOCALE = process.env.VUE_APP_I18N_LOCALE
localize(LOCALE)

/**
 * Definir prototipo locale para cambiar el idioma en vee-validate.
 *
 * @author Valentin Agudelo Aquite
 * @version 1.0.0
 * @since 26/02/2020 10:24 AM.
 */
Object.defineProperty(Vue.prototype, 'locale', {
  get () {
    return LOCALE
  },
  set (val) {
    LOCALE = val
    localize(val)
  }
})
